export const kGraphTileType = "Graph"
export const kV2GraphType = "graph"
export const kGraphTileClass = "codap-graph"

export const kGraphIdPrefix = "GRPH"
